module.exports = __webpack_public_path__ + "media/images/front/university_hospitals/university_nms-04dd29a3558a6a9da329e93863bc83cc.png";